export default "<template>\r\n  <v-progress-linear value=\"15\"></v-progress-linear>\r\n</template>\r\n";